import {createContext, useContext, ReactNode, useState, useCallback} from "react"

import {IBeerProps, ISelectedBeerProps} from "../../interfaces/index"
import {TPartyTypeProps, TPartyTypeNoneProps} from "../../types/index"

import {AxiosResponse} from "axios"
import {api} from "../../services/api"


interface IChildrenProps {
    children: ReactNode
}

interface IDashboardContextData {
    beers: IBeerProps[]
    selectedBeers: ISelectedBeerProps[]
    selectedPartyType: TPartyTypeNoneProps
    setSelectedBeers: React.Dispatch<React.SetStateAction<ISelectedBeerProps[]>>
    setSelectedPartyType: React.Dispatch<React.SetStateAction<TPartyTypeNoneProps>>
    getBeers: () => Promise<void>
    addBeer: (beer: IBeerProps, type: TPartyTypeProps) => void
    deleteBeer: (beer: ISelectedBeerProps) => void
}


export const DashboardContext = createContext({} as IDashboardContextData)


export const CartProvider = ({children}: IChildrenProps) => {

    const [beers, setBeers] = useState<IBeerProps[]>([])
    const [selectedBeers, setSelectedBeers] = useState<ISelectedBeerProps[]>([])

    const [selectedPartyType, setSelectedPartyType] = useState<TPartyTypeNoneProps>("None")

    const getBeers = useCallback(async() => {
        try {
            const response: AxiosResponse<IBeerProps[]> = await api.get("https://api.punkapi.com/v2/beers")

            setBeers([...beers, ...response.data])

        } catch(err) {
            console.error(err)
        }
    }, [])

    const addBeer = (beer: IBeerProps, type: TPartyTypeProps) => {
        const cloneBeer = {...beer}

        const addedBeerType: ISelectedBeerProps = Object.assign(cloneBeer, {type: type})

        setSelectedBeers([...selectedBeers, addedBeerType])  
    }

    const deleteBeer = (beer: ISelectedBeerProps) => {
        const beerIndex = selectedBeers.findIndex(currentSelectedBeer => currentSelectedBeer.id === beer.id && currentSelectedBeer.type === selectedPartyType)

        setSelectedBeers(selectedBeers.filter((currentSelectedBeer, index) => {
            if(index !== beerIndex) {
                return currentSelectedBeer
            }
        }))
    }

    return (
        <DashboardContext.Provider value={{beers, selectedBeers, selectedPartyType, getBeers, addBeer, setSelectedBeers, setSelectedPartyType, deleteBeer}}>
            {children}
        </DashboardContext.Provider>
    )
}

export const useDashboardContext = () => useContext(DashboardContext)